<template>
  <div class="horizFlex">
      <div 
        ref="floorEl"
        class="floor"
        @pointerdown="onFloorPointerDown"
        @pointermove="onPointerMove"
        @pointerup="onPointerUp"
        @pointerleave="onPointerUp"
        @click="onFloorClick"
      >
          <div
            v-for="table in filteredTables"
            :key="table.id"
            :class="tableclass(table)"
            
            :data-id="table.id"
            :style="{
              gridColumn: `${table.positionX} / span ${table.sizeX}`,
              gridRow: `${table.positionY} / span ${table.sizeY}`
            }"
          >
            <div class="vertFlex">
              <label>{{ tableLabel(table) }}</label>  
              <label v-if="showEmployees && !table.isTextbox">{{ serverForTable(table.id) }}</label>
            </div>
            
           
          </div>
      
        <updatetable ref="updatetableviewer" :locationId="tableLocationId" :inTable="tableToEdit" :tables="tables" :inPosX="positionXToEdit" :inPosY="positionYToEdit" 
              :defaultTableNumber="nextTableNumber"  :isAdd="tableToEdit.id==0" :gridSize="gridSize" @savetable="savetable" @cancelupdate="cancelUpdateTable" @removetable="removetable" />
      </div>
      <div height="20" class="employeeDiv">

        <div v-if="showSelectLocation">
              <div class="entryTextDiv">
                  <label class="entryLabel" for="locationselect">Location</label>
              </div>
              <select name="" id="locationselect" class='entrySelect' v-model="tableLocationId" required @change="selectLocation">
                  <option v-for="loc in locationList" :key="loc.id" :value="loc.id" >
                      {{loc.name}}
                  </option>
              </select>
          </div>
         <div class="horizFlex" v-if="allowTableEdit">
            <input id="showinactivecheck" class="entryCheckbox" type="checkbox" v-model="showInactiveTables"  />
            <label class="entryLabel" for="showinactivecheck">Show Inactive</label> 
         </div>
         <div>
            <smallbutton toplabel="Update Tables" @click="tablesEditable=true" v-if="!tablesEditable  && allowTableEdit && !updatingServerTables" :disabled="disableUpdateTable"/>
            <smallbutton toplabel="Assign Servers" @click="updatingServerTables=true" v-if="showEmployees && !updatingServerTables && !tablesEditable " :disabled="tablesEditable" />
         </div>
        


        <label  v-if="tablesEditable">Click blank space to add a new table. </label>
        <br>
        <label v-if="tablesEditable">Click existing table to edit or drag to move.</label>
        <br>
        <smallbutton toplabel="Done Editing Tables" @click="tablesEditable=false; inEdit=false" v-if="tablesEditable"/>

        <div v-if="!tablesEditable && showEmployees">

          
           <label v-if="updatingServerTables && selectedserver.id>0">Click table to assign to {{ selectedserver.name }}</label>
          <br>
          
          <div v-for="e in employeeList_Culinary" :key="e.id" :value="e.id" v-if="updatingServerTables">
            <div :class="employeeLinkDivClass(e)">
              <linkbutton :toplabel="updatetablestext(e)" @click="startudpateservertables(e)" />
            </div>
          </div>

          <smallbutton toplabel="Done Assigning Tables" @click="updatingServerTables=false; inEdit=false" v-if="updatingServerTables"/>


        </div>
        
      </div>
  </div>
  
 
  </template>
  
  <script>
  import {mapFields} from 'vuex-map-fields'
  import datamethods from '../../services/datamethods.js'
  import smallbutton from '../controls/button.vue'
  import securityhelper from '../../services/securityhelper.js'
  import linkbutton from '../controls/linkbutton'
  import updatetable from './updatetable.vue'

  export default {
      name:'tableadmin',
      mixins:[datamethods, securityhelper],
      components:{
          smallbutton,
          linkbutton,
          updatetable

      },
      props:{
            disabled:{
                type:Boolean,
                default:false
            },
            inSelectedTableNumber:{
              type:Number
            }
      },
      watch: {
            inSelectedTableNumber(newVal, oldVal) {
                console.log('hit the watch table admin')
                this.setSelectedTable()
            }
        },
      computed:{
          ...mapFields([
    
              'pleaseWait',
              'pleaseWaitText',
              'loggedInUser',
              'locationList',
              'location'

          ]),
          nextTableNumber(){
            var max=0
            this.tables.forEach(myFunction2)
                    function myFunction2(item, index, arr) {
                    let t=arr[index]
                    if(t.tableNumber>max){   
                        max=t.tableNumber
                    } 
                }
            return max+1
          },
          filteredTables(){
            if(this.showInactiveTables){
              return this.tables
            }else{
              var filtered =[]

                this.tables.forEach(myFunction2)
            
                function myFunction2(item, index, arr) {
                    let t=arr[index]
                    if(t.isActive ){
                        filtered.push(t)
                    }
                } 
                return filtered
            }
          },
          disableUpdateTable(){
            return this.updatingServerTables || !this.canAccess(this.updateTableSecurityName)
          },
          
          


      },
    
    mounted(){

      //if we are showing location, default to user location
      //else, default to overall selected location
      if(this.tableLocationId==-1){
        if(this.showSelectLocation){
          this.tableLocationId=this.loggedInUser.LocationId}
        else{this.tableLocationId=this.location.id}
      }
      this.getTables()
      if(this.showEmployees){
        this.selectedserver={id:0,name:null}
        this.getEmployeeList_Culinary()
        this.getTableEmployees()
      }
      
    },
    data(){
          return{
            

            //big settings for what is allowed
            gridSize: 24,
            allowTableEdit:false,
            showEmployees:false,
            showSeatCount:false,
            showGrid:false,
            showTablesWithGuests:true,
            showSelectLocation:false,
            showInactiveTables:false,
            updateTableSecurityName:'UpdateTables On POS',



            tableLocationId:-1,
            lastSelectedTable:-1,
            
            tablesEditable:false,
            responseMessage:'',
            trueParam:true,
            falseParam:false,
            activeTable:null,

            tables:[],
        
            draggingTable: null,
            dragStartPos: null,
            didDrag: false,
            lastClickWasDrop:false,

            

            inEdit:false,
            tableToEdit:{id:0},
            positionXToEdit:1,
            positionYToEdit:1,
            employeeList_Culinary:[],
           
            updatingServerTables:false,
            selectedserver:{id:0, name:null},

            tabletosave:{},
            tableemployeelist:[],
            tableticketlist:[]
          }
    },
    methods:{
      setSelectedTable(){
            var id = 0
            var innumber = this.inSelectedTableNumber
            console.log('setseltable '  + innumber)
            if(innumber>0){
              this.tables.forEach(myFunction2)
                function myFunction2(item, index, arr) {
                  let t=arr[index]
                  if(t.tableNumber==innumber){   
                      id=t.id
                  } 
              }
              this.lastSelectedTable=id
            }else{this.lastSelectedTable=0}
            
          },
      employeeLinkDivClass(e){
            if(e.id==this.selectedserver.id){
              return "employeeLinkDivSelected"
            }else{return "employeeLinkDiv"}
          },
      selectLocation(){
        this.getTables()
        if(this.showEmployees){
          this.selectedserver={id:0,name:null}
          this.getEmployeeList_Culinary()
          this.getTableEmployees()
        }
      },
      tableLabel(table){
        var t = 'T'
        if(table.isTextbox){
          t=table.text
        }
        else{
          t='T' + table.tableNumber
          if(this.showSeatCount){t = t + ' (S' + table.seatsAvailable + ')'}
        }
        
        return t
      },
      async getTables(){
        this.responseMessage=null
        let req = {
            ID:this.tableLocationId
        }
          //call api
          this.$store.dispatch('beforeAPI');
          var response = await this.callAPI(req,'tablelist')
          //handle response
      
          if(response.Successful){
              this.tables=response.locationTableList
              
          }else{
          this.responseMessage = response.Message
          }
          this.pleaseWait=false;   
      },
      async getEmployeeList_Culinary(){
            let req = {
              ID:this.tableLocationId
            }
            //call api
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'employee_culinary')
            //handle response
         
            if(response.Successful){
              this.employeeList_Culinary=response.ItemList
              this.setEmployeeColors()
            }else{
              this.responseMessage = response.Message
            }
            this.pleaseWait=false;
         },
         setEmployeeColors(){
            this.employeeList_Culinary.forEach(myFunction2)
                function myFunction2(item, index, arr) {
                let t=arr[index]
                t.itemClass="table" + String(index + 1)
            }
         },
      updatetablestext(employee){
        return employee.name 
      },
      startudpateservertables(employee){
        this.selectedserver=employee
        this.updatingServerTables=true
      },
      serverForTable(id){
            var server=null
            this.tableemployeelist.forEach(myFunction2)
                    function myFunction2(item, index, arr) {
                    let t=arr[index]
                    if(t.tableId==id){   
                        server = t.employeeName
                    } 
                }
                if(server!=null){
                  if(server.length>6){
                    server = server.slice(0,6)
                  }
                }
                
              return server

          },
          serverColorByTable(id){
            
            if(!this.showEmployees){
              var cls ='tableactive'
              if(id==this.lastSelectedTable){cls = cls + ' tableselected'}
              return cls
            }
            var server=null
            var myclass="table0"
            this.tableemployeelist.forEach(myFunction2)
                    function myFunction2(item, index, arr) {
                    let t=arr[index]
                    if(t.tableId==id){   
                        server = t.employeeName
                    } 
                }
               // console.log('server for color ' + id + ' ' + server)
                if(server!=null){
                  this.employeeList_Culinary.forEach(myFunction3)
                    function myFunction3(item, index, arr) {
                    let t=arr[index]
                    if(t.name==server){   
                        myclass=t.itemClass
                    } 
                }
                }
              
                return myclass
          },

      tableclass(table){
	        var cls="table"

          if(table.isTextbox && table.isActive){
            cls=cls + ' tabletextbox'
          }
	        else if(table.isActive){
            
            cls=cls + ' ' +  this.serverColorByTable(table.id)
	        }else{
	          cls=cls + ' tableinactive'
	        }
          if(this.draggingTable!=null){
            if(this.draggingTable.id===table.id){
              cls = cls + ' dragging'
            }
          }

          //if we are showing guests, and this table has them, add that class
          if(this.showTablesWithGuests){
            if(this.TableHasGuests(table.id)){
              cls = cls + ' tablehasguests'
            }
          }

	        return cls


          //:class="{ dragging: draggingTable?.id === table.id }"
	    },
     TableHasGuests(id){
        var hasguests=false
         this.tableticketlist.forEach(myFunction2)
              function myFunction2(item, index, arr) {
              let t=arr[index]
              if(t.id==id){   
                  hasguests=true
              } 
          }
          return hasguests
      },
      async savetable(table){
        this.tabletosave=table
         this.saveTableToDB()
        return 

      },
      async removetable(table){
        this.tabletosave=table
        this.removeTableFromDB()
      },
      async saveTableToDB(){
        this.responseMessage=null
        let req = {
            locationTable:this.tabletosave,
        }
        this.$store.dispatch('beforeAPI');
        var response = await this.callAPI(req,'updatetable')
          //handle response
      
          if(response.Successful){
              this.getTables()
              
          }else{
          this.responseMessage = response.Message
          }
          this.pleaseWait=false;  
          this.inEdit=false
      },
      async removeTableFromDB(){
        this.responseMessage=null
        let req = {
            locationTable:this.tabletosave,
        }
        this.$store.dispatch('beforeAPI');
        var response = await this.callAPI(req,'removetable')
          //handle response
      
          if(response.Successful){
              this.getTables()
              
          }else{
          this.responseMessage = response.Message
          }
          this.pleaseWait=false;  
          this.inEdit=false
      },
      cancelUpdateTable(){
        console.log('cancel')
        this.$nextTick(()=>{
          this.inEdit=false
        })
      },
      onFloorPointerDown(e) {
        if(!this.tablesEditable && !this.updatingServerTables){return}
        const tableEl = e.target.closest('.table')
        if (!tableEl) return

        const id = Number(tableEl.dataset.id)
        const table = this.tables.find(t => t.id === id)
        if (!table) return

        this.inEdit=true
        this.draggingTable = table
        this.dragStartPos = { x: e.clientX, y: e.clientY }
        this.didDrag = false
        
        e.target.setPointerCapture(e.pointerId)
      },

    onPointerMove(e) {
      if(!this.tablesEditable){return}
      if (!this.draggingTable) return

      const dx = Math.abs(e.clientX - this.dragStartPos.x)
      const dy = Math.abs(e.clientY - this.dragStartPos.y)

      if (dx > 5 || dy > 5) {
        this.didDrag = true
      }

      const floor = this.$refs.floorEl
      const rect = floor.getBoundingClientRect()

      const x = e.clientX - rect.left
      const y = e.clientY - rect.top

      let posX = Math.floor((x / rect.width) * this.gridSize) + 1
      let posY = Math.floor((y / rect.height) * this.gridSize) + 1

      // keep table inside grid
      posX = Math.max(1, Math.min(posX, this.gridSize - this.draggingTable.sizeX + 1))
      posY = Math.max(1, Math.min(posY, this.gridSize - this.draggingTable.sizeY + 1))

      this.draggingTable.positionX = posX
      this.draggingTable.positionY = posY
    },

    async onPointerUp(e) {
      if(!this.tablesEditable && !this.updatingServerTables){return}
      if (!this.draggingTable) return

      

      e.target.releasePointerCapture(e.pointerId)

      if(this.updatingServerTables){
        console.log('assign')
        this.assignTableToServer(this.draggingTable)
       
      }

      else if (!this.didDrag) {
        // treat as click
        console.log('in treat as click')
        this.openTableEditor(this.draggingTable)
      }
      await this.savetable(this.draggingTable)
      this.draggingTable = null
      this.dragStartPos = null
      this.didDrag = false
      
      this.lastClickWasDrop=true
      
      console.log('end of onpointer up')
    },
    onFloorClick(e) {
      
      if(this.inEdit){
        if(this.lastClickWasDrop){
          this.inEdit=false
          this.lastClickWasDrop=false
        }
        //this.inEdit=false
        return
      }
      const floor = this.$refs.floorEl
      const tableEl = e.target.closest('.table')

      // clicked on an existing table → open table editor
      if (tableEl && floor.contains(tableEl)) {
        const id = Number(tableEl.dataset.id)
        const table = this.tables.find(t => t.id === id)
        console.log('in onfloorclcik ' + this.didDrag)

        //if we can't edit, still tell the parent that we clicked the table
        if(!this.tablesEditable ){
          if(!this.disabled){
            this.lastSelectedTable=table.id
            this.$emit('selecttable',table)
          }
          
          return
        }

        this.openTableEditor(table)
        return
      }

      if(!this.tablesEditable){return}

      // clicked empty space → calculate cell
      const rect = floor.getBoundingClientRect()
      const x = e.clientX - rect.left
      const y = e.clientY - rect.top

      // convert pixel coordinates to grid column/row
      const positionX = Math.floor((x / rect.width) * this.gridSize) + 1
      const positionY = Math.floor((y / rect.height) * this.gridSize) + 1
      console.log(positionX + ' ' + positionY)
      this.openEmptyCellEditor({ positionX, positionY })
    },
    openTableEditor(table) {
      this.inEdit=true
      
      this.tableToEdit = table
      this.$nextTick(()=>{
        console.log('Edit table', table)
        this.$refs.updatetableviewer.update()
      })
    },
    openEmptyCellEditor(cell) {
      this.inEdit=true
      this.tableToEdit={id:0}
      this.positionXToEdit=cell.positionX
      this.positionYToEdit=cell.positionY
      
      this.$nextTick(()=>{
        console.log('Empty cell clicked at:', cell.positionX + ' ' + cell.positionY + ' ' + this.positionXToEdit + ' ' + this.positionYToEdit)
        this.$refs.updatetableviewer.update()
      })
      // open "add new table" UI
    },
    assignTableToServer(table){
      console.log('assign ' + table.id)
      var employee = this.selectedserver

      this.saveTableEmployeeToDB(employee.id,table.id)

     
       
    },
          
    async saveTableEmployeeToDB(empid, tableid){
        this.responseMessage=null
        let req = {
            locationTableEmployee:{
              employeeId:empid,
              tableId:tableid
            }
        }
        this.$store.dispatch('beforeAPI');
        var response = await this.callAPI(req,'updatetableemployee_current')
          //handle response
      
          if(response.Successful){
              this.getTableEmployees()
              
          }else{
          this.responseMessage = response.Message
          }
          this.pleaseWait=false;  
          this.inEdit=false
      },   
      async getTableEmployees(){
        this.responseMessage=null
        let req = {
            ID:this.tableLocationId
        }
          //call api
          this.$store.dispatch('beforeAPI');
          var response = await this.callAPI(req,'tableemployeelist')
          //handle response
      
          if(response.Successful){
              this.tableemployeelist=response.LocationTableEmployeeList
              
          }else{
          this.responseMessage = response.Message
          }
          this.pleaseWait=false;   
      },
      async getTableTickets(){
        this.responseMessage=null
        let req = {
            ID:this.tableLocationId
        }
          //call api
          this.$store.dispatch('beforeAPI');
          var response = await this.callAPI(req,'tableticketlist')
          //handle response
      
          if(response.Successful){
              this.tableticketlist=response.locationTableList
              
          }else{
          this.responseMessage = response.Message
          }
          this.pleaseWait=false;   
      },
      
    },
    
  }
  </script>
  
  <style>
    :root {
    --tableSize: 500px;
     --background-image:none; 
      /* --background-image:linear-gradient(to right, #ddd 1px, transparent 1px),
    linear-gradient(to bottom, #ddd 1px, transparent 1px);  */
  }

 .floor {
  display: grid;
  grid-template-columns: repeat(24, 1fr);
  grid-template-rows: repeat(24, 1fr);
   width: var(--tableSize);
  height: var(--tableSize);
  border: 2px solid #333;
  touch-action: none; /* critical for touch drag */

   /* grid lines */
  background-image:var(--background-image);
  background-size:
    calc(100% / 24) calc(100% / 24);
}
.floor::after {
  content: '';
  position: absolute;
  inset: 0;
  pointer-events: none;
}
.table {
  background: #4caf50;
  border-radius: 8px;
  
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  text-align: center;
}
.tableactive{
    background: var(--color-green);
    color: white;
}
.tableselected{
  border:2px solid yellow;
  color: white;
}
.tableinactive{
  background:lightgray;
  color:white
}
.dragging {
  opacity: 0.8;
  cursor: grabbing;
}
.table0{
  background:black;
}
.table1{
  background:rgb(236, 130, 130);
}
.table2{
  background:rgb(138, 138, 238);
}
.table3{
  background:rgb(103, 172, 103);
}
.table4{
  background:rgb(241, 126, 241);
}
.table5{
  background:rgb(177, 145, 87);
}
.tabletextbox{
  background:white;
  color:black;
  border: 1px solid gray;
  
}
.employeeDiv{
  margin:10px;
  width:300px;
}
.employeeLinkDiv{
  text-align: center;
  padding:10px;

}
.employeeLinkDivSelected{
  text-align: center;
  padding:10px;
  font-size: larger;
  font-weight: bold;
  color:var(--highlight-color);
}
.tablehasguests{
  background-color: #727572;
}
  </style>